// extracted by mini-css-extract-plugin
export var acceptButton = "_17-6";
export var backdropBlur = "_17-0";
export var fullContent = "_17-5";
export var link = "_17-7";
export var linkIcon = "_17-8";
export var sideContent = "_17-4";
export var sideImage = "_17-3";
export var sideImageWrapper = "_17-2";
export var splitLayout = "_17-1";